module.exports = "<svg viewBox=\"0 0 12 8\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.303655 1.2475665C5.978463.919727 5.451508.9171673 5.123189 1.2418322L1.4561 4.8681077c-.330229.3265533-.334962.860765-.010571 1.1931952.324391.3324302.855065.3371943 1.185293.010641L5.71752 3.0339626l2.996909 3.0322471c.327083.3297463.857778.3301378 1.18534.0008746.327563-.3292633.327952-.8634961.000869-1.1932424L6.303655 1.2475665z\" stroke=\"#B5D2E1\" stroke-width=\"2\" fill=\"#B5D2E1\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/images/svg/ui-dropdown-caret.svg
// module id = wP5d
// module chunks = 89